import PropTypes from "prop-types";
import React from "react";
import { KNOT_HOST_MAP } from "../../../utils/urls.js";
const Context = /*#__PURE__*/React.createContext();
export const useTKHost = () => React.useContext(Context);
export const TKHostProvider = _ref => {
  let {
    env,
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: KNOT_HOST_MAP[env] || ''
  }, children);
};
process.env.NODE_ENV !== "production" ? TKHostProvider.propTypes = {
  env: PropTypes.oneOf(['qa', 'production']),
  children: PropTypes.node.isRequired
} : void 0;
export const TKHostConsumer = Context.Consumer;